import React, { useEffect, useState, useContext } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Col } from 'react-bootstrap';
import { containsEnglish, containsTibetan } from '../common/utils';
import { useView } from '../../hooks/useView';
import { EwtsConverter } from './src/EwtsConverter.mjs';
import { useDictionaryStore } from '../../hooks/useDictionaryStore';

const WYLIE = '73|roman.scholar';
const TIBETAN = '75|pri.orig.sec.roman';

export default function TranslationForm({ submit, reset, defval }) {
    const { terms } = useView();
    const { setParser } = useDictionaryStore();
    const [status, setStatus] = useState('ok');

    const ewts = new EwtsConverter();

    const submitMe = (e) => {
        e.preventDefault();
        checkForTib(e);
        submit(e);
    };

    const checkTextArea = () => {
        const tael = document.getElementById('translationForm.tibetan');
        let taval = tael.value;
        // Check setting
        if (containsTibetan(taval) && terms === WYLIE) {
            taval = ewts.to_ewts(taval);
            tael.value = taval;
        } else if (!containsTibetan(taval) && terms === TIBETAN) {
            taval = ewts.to_unicode(taval);
            tael.value = taval;
        }

        if (containsTibetan(taval)) {
            tael.classList.add('bo');
        } else {
            tael.classList.remove('bo');
        }
    };

    const checkTextBox = (e) => {
        if (e?.which === 13 && !e.shiftKey) {
            e.preventDefault();
            submitMe(e);
        }

        const tael = document.getElementById('translationForm.tibetan');
        let taval = tael.value;

        if (
            terms === TIBETAN &&
            containsEnglish(taval) &&
            containsTibetan(taval) &&
            localStorage.getItem('revert2Wylie') === 'true'
        ) {
            taval = ewts.to_ewts(taval).replace(/[[\]]/g, '');
            tael.value = taval;
        }
    };

    const checkForTib = (e) => {
        checkTextArea();
    };

    useEffect(() => {
        if (status === 'ok') {
            checkTextArea();
        }
    }, [terms]);

    useEffect(() => {
        let isMounted = true;
        async function testttt() {
            try {
                // '/proxy/ttt/'
                fetch(
                    'https://ttt.thlib.org/org.thdl.tib.scanner.RemoteScannerFilter?dicts=32766&text=%E0%BD%93%E0%BD%B2%E0%BC%8B&_=1758559654735&jwf=axiosTest',
                    { method: 'GET' }
                )
                    .then(async (res) => {
                        const text = await res.text(); // Get the raw response as text
                        let data, isJson;

                        try {
                            const jsonString = text
                                .replace(/^axiosTest\(/, '')
                                .replace(/\)[\s;]*$/, '');
                            data = JSON.parse(jsonString); // Try to parse JSON
                            isJson = true;
                        } catch (e) {
                            data = text; // Fallback to plain text (likely HTML)
                            isJson = false;
                        }

                        return { ok: res.ok, status: res.status, isJson, data };
                    })
                    .then(({ ok, status, isJson, data }) => {
                        if (!ok) {
                            console.error(
                                `Request failed with status ${status}`
                            );
                        }

                        if (typeof data === 'string') {
                            //console.log('Received HTML:');
                            setStatus('404');
                        } else {
                            //console.log('Received JSON');
                            setStatus('ok');
                        }
                    })
                    .catch((err) => {
                        console.error('Network error:', err);
                        setStatus('404');
                    });
            } catch (err) {
                console.log('error testing translation tool api', err);
            }
        }

        testttt();

        // Set parser to JAVA because PHP doesn't work

        setParser('java');
        localStorage.setItem('tttParser', 'java');

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <Form id="tt-form" className="transtool-form" onSubmit={submitMe}>
            <Form.Row>
                {status === '404' && (
                    <Col sm={12}>
                        <p className="m-5 alert alert-danger text-center font-125">
                            Translation Tool API is down!
                        </p>
                    </Col>
                )}
                {status === 'ok' && (
                    <Col sm={12}>
                        <Form.Group
                            className="mb-3"
                            controlId="translationForm.tibetan"
                        >
                            <Form.Control
                                as="textarea"
                                rows={3}
                                className={containsTibetan(defval) ? 'bo' : ''}
                                onKeyDown={checkTextBox}
                                /*onBlur={checkTextArea} */
                                placeholder={`Enter a Tibetan word or phrase in either Unicode Tibetan or Wylie transliteration.`}
                                defaultValue={defval}
                            />
                        </Form.Group>
                        <Form.Group className="btns">
                            <Button
                                variant="primary"
                                type="submit"
                                className="submit"
                                onClick={checkTextArea}
                                id="tt-btn-submit"
                            >
                                Translate
                            </Button>
                            <Button
                                variant="primary"
                                type="reset"
                                className="reset"
                                onClick={(e) => {
                                    const ta = document.getElementById(
                                        'translationForm.tibetan'
                                    );
                                    ta.value = '';
                                    ta.defaultValue = '';
                                    reset(e);
                                }}
                            >
                                Reset
                            </Button>
                        </Form.Group>
                    </Col>
                )}
            </Form.Row>
        </Form>
    );
}
